import { NSALoginPage } from "namirasoft-account-react";

function LoginPage()
{
	return (
		<NSALoginPage
			title="Namirasoft Email Sender"
			logo="https://static.namirasoft.com/image/namirasoft/email-sender/logo/base.png"
			background={{ image: "https://static.namirasoft.com/image/namirasoft/email-sender/background/base.webp" }}
		/>
	);
}

export default LoginPage;